import { render, staticRenderFns } from "./TissueCropFormGroups.vue?vue&type=template&id=4e1353c8"
import script from "./TissueCropFormGroups.vue?vue&type=script&lang=js"
export * from "./TissueCropFormGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports